/**
 * mwApp.ssais module <br>
 * Work with ssais
 *
 * @namespace mwApp/ssais
 */

import ssaisConfig from './ssais.config'
import SsaiSettingsCtrl from './ssaiSettings.controller'
import AddSsaiParameterCtrl from './addParameter.controller'

export default
angular.module('mwApp.ssais', [])
  .config(ssaisConfig)
  .controller('SsaiSettingsCtrl', SsaiSettingsCtrl)
  .controller('AddSsaiParameterCtrl', AddSsaiParameterCtrl)
